// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const getGalleryMedia = createAsyncThunk(
	"userpanel/getGalleryMedia",
	createApiCall(async ({ customPage = 1, customHash = null }, client) => {
		const response = await client.get(`/media/all/panel`, {
			params: {
				page: customPage,
				hash: customPage === 1 ? null : customHash,
			},
		});

		return {
			data: response.data,
			counters: response.counters,
		};
	})
);

// ############################################################
